import { useEffect, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { GenerateApiKeyServ, GetApiKey } from "../../Services/Settings";

export interface ApiKeyObj {
    color: string;
    msg: string;
}

interface GenerateApiKeyProps {
    onChangeMessagehandler: (color: string, msg: string) => void;
}

const GenerateApiKey: React.FunctionComponent<GenerateApiKeyProps> = (props) => {

    const [apiKeyValue, setApiKeyValue] = useState<string>("");
    const { t } = useTranslation();
    const [isCopied, setIsCopied] = useState<boolean>(false);
    const [isGenerate, setIsGenerate] = useState<boolean>(false);

    useEffect(() => {
        GetApiKey().then((resp) => {
            if (resp && resp.apiKey) {
                setApiKeyValue(resp.apiKey);
            }
        }).catch((error) => {
            props.onChangeMessagehandler("error", "Failed to fetch API Key.");
        });
    }, []);

    const handleCopy = () => {
        if (apiKeyValue) {
            setIsCopied(true);
            props.onChangeMessagehandler("success", "API Key copied successfully!");
            setTimeout(() => {
                setIsCopied(false);
            }, 2000);
        }
    };

    const Generate = async () => {
        try {
            setIsGenerate(true);
            setIsCopied(false);

            const resp = await GenerateApiKeyServ();

            if (resp && resp.apiKey) {
                setApiKeyValue(resp.apiKey);
                props.onChangeMessagehandler("success", "API Key generated successfully!");
            } else {
                props.onChangeMessagehandler("error", "Failed to generate API Key. Please try again.");
            }

        } catch (error: any) {
            let errorMessage = "Failed to generate API Key. Please try again.";
            if (error.response?.status) {
                switch (error.response.status) {
                    case 401:
                        errorMessage = "Please authenticate to generate API Key.";
                        break;
                    case 500:
                        errorMessage = "Server error. Please try again later.";
                        break;
                    default:
                        errorMessage = error.response.data?.message || errorMessage;
                }
            } else if (!error.response) {
                errorMessage = "Network error. Please check your connection.";
            }
            props.onChangeMessagehandler("error", errorMessage);

        } finally {
            setIsGenerate(false);
        }
    };

    return (
        <div className="cp-card mt-4 mb-4 padd-20">
            <div className="manager-header mb-4">
                <h2 className="manager-title">{t("settings.apiKey")}</h2>
            </div>
            <div className="row">
                <div className="col-md-5 mb-3">

                    <div className="input-group">
                        <input
                            id="apiKey"
                            type="text"
                            className="form-control input-settings"
                            placeholder={"API Key"}
                            value={apiKeyValue}
                            readOnly
                        />

                        <div className="btn-group">
                            <CopyToClipboard
                                text={apiKeyValue || ""}
                                onCopy={handleCopy} >

                                <button
                                    className={`input-group-text border-trans back-trans ${apiKeyValue == "" ? 'disabled' : ''}`}
                                    title={apiKeyValue == "" ? "Generate an API Key first" : "Copy API Key"}
                                    type="button" >
                                    <>
                                        <i
                                            className="fa-solid fa-copy color-746AFF"
                                        />
                                        {isCopied && <span className="color-746AFF marg-left-5">Copied</span>}
                                    </>
                                </button>
                            </CopyToClipboard>
                        </div>
                    </div>
                </div>

                <div className="col-md-4  mb-3 d-flex align-items-center justify-content-end">
                    <button
                        type="button"
                        className={`button-dash back-746AFF color-FFFFFF border-746AFF padd-15-30 ${isGenerate ? 'disabled' : ''}`}
                        onClick={Generate}
                    >
                        {t("generateDescTitle.generate")}
                        {isGenerate && (
                            <div
                                className="spinner-border text-white ms-2"
                                style={{ width: "20px", height: "20px" }}
                                role="status"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        )}
                    </button>
                </div>
            </div >
        </div >

    );
};

export default GenerateApiKey;